<template>
  <div>
    <CRow>
      <CCol md="12">

        <CRow>
          <CCol>
            <CCard>
              <CCardHeader>
                <CRow>
                  <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                    <strong>تنظیمات</strong>
                  </CCol>
                  <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                    <CIcon @click.native="update_business_profile()" name="saveNew"/>
                  </CCol>

                </CRow>
              </CCardHeader>
              <CCardBody>
                <CInput
                    label="ساعت شروع"
                    :value.sync="start_time.value"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                />
                <CInput
                    label="ساعت پایان"
                    :value.sync="end_time.value"

                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                />

                <CSelect
                        :label="$t('tables.status')"
                        :value.sync="status.value"

                        :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                        :options="[this.$t('components.statusOn'),this.$t('components.statusOff')]"
                />

              </CCardBody>
            </CCard>
          </CCol>
          <CCol>
            <CCard>
              <CCardHeader>
                <CRow>
                  <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                    <strong>هزینه حمل و نقل</strong>
                  </CCol>
                  <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                    <CIcon @click.native="update_business_profile" name="saveNew"/>
                  </CCol>
                </CRow>
              </CCardHeader>
              <CCardBody >

                <CInput
                        label="هزینه پیک"
                        :value.sync="delivery_price.value"

                        :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                />
                <CInput
                        label="کیلومتر مجاز"
                        :value.sync="route_long.value"

                        :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                />
                <CInput
                        label="هزینه هر کیلومتر"
                        :value.sync="route_extra.value"

                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                />
                <CInput
                    label="مقدار بار مجاز"
                    :value.sync="route_weight.value"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                />
                <CInput
                    label="هزینه هر کیلو اضافه"
                    :value.sync="route_weight_extra.value"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                />


              </CCardBody>
            </CCard>

          </CCol>
          <CCol>
            <CCard>
              <CCardHeader>
                <CRow>
                  <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                    <strong>روز های کاری</strong>
                  </CCol>
                  <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                    <CIcon @click.native="update_business_profile" name="saveNew"/>
                  </CCol>
                </CRow>
              </CCardHeader>
              <CCardBody >


          <CRow>
            <CCol col="3">
            <CInputCheckbox
                label="شنبه"
                :checked.sync="week_days[0]"

            />
          </CCol>
            <CCol col="3">
            <CInputCheckbox
                label="یکشنبه"
                :checked.sync="week_days[1]"
            />
          </CCol>
            <CCol col="3">
            <CInputCheckbox
                label="دوشنبه"
                :checked.sync="week_days[2]"
            />
          </CCol>
            <CCol col="3">
            <CInputCheckbox
                label="سه شنبه"
                :checked.sync="week_days[3]"
            />
          </CCol>
            <CCol col="3">
            <CInputCheckbox
                label="چهارشنبه"
                :checked.sync="week_days[4]"
            />
          </CCol>
            <CCol col="3">
            <CInputCheckbox
                label="پنجشنبه"
                :checked.sync="week_days[5]"
            />
          </CCol>

          <CCol col="3">
            <CInputCheckbox
                label="جمعه"
                :checked.sync="week_days[6]"
            />
          </CCol>
        </CRow>


              </CCardBody>
            </CCard>

          </CCol>

        </CRow>

      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];

import moment from 'moment-jalaali'


export default {
  name: 'Login',
  components: {
  },
  data() {
    return {

      date_time_locale: this.$i18n.locale,
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      name: '',
      vat_date: '',
      date: '',
      local: this.$i18n.locale,
      file: null,
      color: '#ffffff',
      code: '',
      start_time:{},
      end_time:{},
      status:{},
      delivery_price:{},
      route_long:{},
      route_extra:{},
      route_weight:{},
      route_weight_extra:{},
      weekdays:{},

      previewImage: '/img/placeholder.png',
      description: '',
      phone_objects: [{phone_type: 19, phone: '', row_id: 1}],
      email_objects: [{phone_type: 19, phone: '', row_id: 1}],
      website_objects: [{phone_type: 19, phone: '', row_id: 1}],
      bissiness_profile: {registeredDate: '', vATDate: '',},

      bissiness_profile_id: 0,
      main_address: {},
      main_address_id: 0,

      items: items.map((item, row_id) => {
        return {...item, row_id}
      }),
      fields: [
        {key: 'row', label: this.$t('tables.row'), _style: 'width:10%'},
        {key: 'branchTitle', label: this.$t('tables.name'), _style: 'width:70%'},
        // {key: 'provinceTitle', label: this.$t('tables.province'), _style: 'width:10%'},
        // {key: 'cityTitle', label: this.$t('tables.city'), _style: 'width:10%;'},
        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],
      details: [],
      collapseDuration: 0,
      status_form: 0,
      week_days:[true,true,true,true,true,true,true,true],
      area_items: [],
      selected_area: 0,

      district_items: [],
      selected_district: 0,

      province_items: [],
      selected_province: 0,

      city_items: [],
      selected_city: 0,

      country_items: [],
      selected_country: 0,

    }
  }, mounted() {
    this.$root.root_validate_errors = [];
    // this.get_provinces()
    // this.get_country()
    this.get_bussiness_profile();
    // this.get_main_address();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {

    // 'selected_district': function () {
    //   this.get_areas();
    // },
  },
  methods: {

    get_bussiness_profile() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.bissiness_profile_id);


      axios.post('GetSupplierSettingList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.start_time=content_data.data.filter(x=>x.recId==1)[0]
          self.end_time=content_data.data.filter(x=>x.recId==2)[0]
          self.status=content_data.data.filter(x=>x.recId==3)[0]
          self.delivery_price=content_data.data.filter(x=>x.recId==4)[0]
          self.route_long=content_data.data.filter(x=>x.recId==5)[0]
          self.route_extra=content_data.data.filter(x=>x.recId==6)[0]
          self.route_weight=content_data.data.filter(x=>x.recId==7)[0]
          self.route_weight_extra=content_data.data.filter(x=>x.recId==8)[0]
          self.weekdays=content_data.data.filter(x=>x.recId==9)[0];
if(self.weekdays.value=="0" ||self.weekdays.value==""||self.weekdays.value==null){
  self.weekdays.value="[]";
}
self.week_days = JSON.parse(self.weekdays.value);


            } else {
          // self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    update_business_profile() {
      let self = this;
      const formData = new FormData();
      let url = "UpdateSupplierSetting";
      this.weekdays.value = JSON.stringify(this.week_days);
     var array =[this.start_time,this.end_time,
     this.status,this.route_long,
     this.route_extra,
     this.route_weight,this.route_weight_extra,
     this.delivery_price,
     this.weekdays]

      formData.append('input', JSON.stringify(array));
      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        self.get_bussiness_profile()


      }).catch(function (error) {
        console.log(error);
      });

    },



  }
}

</script>
<style>
.col-form-label {

  font-size: 11px !important;
}
</style>